import { loadLazyComponent } from '@wix/communities-forum-client-commons';

export const DevPlayground = loadLazyComponent(() => import('./dev-playground'));
